import { IsDefined, IsInt, IsISO8601, IsOptional, Matches } from 'class-validator';
import { Type } from 'class-transformer';

export class GetStandAlonePurchaseOrdersByMerchantDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  page = 1;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  limit = 25;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;
}
